import { render, staticRenderFns } from "./AccountTypeCreate.vue?vue&type=template&id=1ebac4e2&scoped=true"
import script from "./AccountTypeCreate.vue?vue&type=script&lang=js"
export * from "./AccountTypeCreate.vue?vue&type=script&lang=js"
import style0 from "./AccountTypeCreate.vue?vue&type=style&index=0&id=1ebac4e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebac4e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ebac4e2')) {
      api.createRecord('1ebac4e2', component.options)
    } else {
      api.reload('1ebac4e2', component.options)
    }
    module.hot.accept("./AccountTypeCreate.vue?vue&type=template&id=1ebac4e2&scoped=true", function () {
      api.rerender('1ebac4e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/account/AccountTypeCreate.vue"
export default component.exports